import React, { useState, useEffect } from 'react'
import '../styles/Dashboard.css'

function Indicators(props) {
	const indTarget = Math.floor(Math.random()*2001)
	const indActual = Math.floor(Math.random()*2001)
	const indTotal = (indTarget > indActual)? indTarget: indActual

	useEffect(() => {
		console.log("use effect")
	}, [])

	return(<div id="indicators">
		<div id="ind-header">
			<div id="ind-title">INDICATORS</div>
			<div id="ind-legend">
				<div>LEGEND</div>
				<div id="ind-legends"><span id="il-target">TARGET</span><span id="il-actual">ACTUAL</span></div>
			</div>
		</div>
		<div id="ind-content">
			<IndicatorBar title="FOS THAT ARE ABLE TO PROVIDE FINANCIAL SERVICES"
				color="#d33860" target={Math.floor(Math.random()*101)} actual={Math.floor(Math.random()*101)} showPercent={true} />
			<IndicatorBar title="CREDIT AND FINANCIAL LITERACY ORIENTATION ATTENDANCE"
				color="#f6cc61" target={indTarget} actual={indActual} total={indTotal} />
			<IndicatorBar title="ARBO MEMBERS"
				color="#f6cc61" target={Math.floor(Math.random()*101)} actual={Math.floor(Math.random()*101)} showPercent={true} />
			<IndicatorBar title="CLUSTERS THAT COMPLETED THE AE PLANS"
				color="#d33860" target={100} actual={Math.floor(Math.random()*101)} showPercent={true} />
		</div>
	</div>)
}

function IndicatorBar(props) {
	const {title, color, showPercent, target, actual, total} = props
	// const [target, setTarget] = useState([])
	// const [actual, setActual] = useState([])
	if(showPercent != true) {
		var calcTarget = (target / total * 100)
		var calcActual = (actual / total * 100)
		var dispTarget = target
		var dispActual = actual
	}
	else {
		calcTarget = target
		calcActual = actual
		dispTarget = target + "%"
		dispActual = actual + "%"
	}
	const tarTextColor = (actual > target && color === "#d33860")? "#fff": "#000"
	const actTextColor = (color === "#f6cc61")? "#000": "#fff"
	return(<div className="ind-bar">
		<div className="ib-title">{title}</div>
		<div className="ib-chart">
			<div className="ib-child ib-child1" style={{
				'background-color': color,
				'color': actTextColor,
				'width': calcActual + "%"
			}}><span>{dispActual}</span></div>
			<div className="ib-child ib-child2" style={{
				'width': calcTarget + "%",
				'color': tarTextColor,
				'border-color': '#000'
			}}><span>{dispTarget}</span></div>
		</div>
	</div>)
}

export default Indicators
